<script setup>
import ProForecastPage from '@/components/ProForecastPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <ProForecastPage />
  </Suspense>
  <ToastHost />
</template>
